var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-plyr',{attrs:{"options":_vm.playerOptions}},[_c('video',{attrs:{"crossorigin":"","playsinline":"","src":_vm.input}})])
}
var staticRenderFns = []

export { render, staticRenderFns }